interface CurrencyConfig {
  symbol: string;
  decimals: number;
}

export const CURRENCY_CONFIG: Record<string, CurrencyConfig> = {
  TRY: { symbol: "\u20BA", decimals: 2 },
  USD: { symbol: "$", decimals: 2 },
  EUR: { symbol: "\u20AC", decimals: 2 },
  GBP: { symbol: "\u00A3", decimals: 2 },
  AED: { symbol: "AED", decimals: 2 },
  SAR: { symbol: "SAR", decimals: 2 },
};

export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) return "$";
  return CURRENCY_CONFIG[currency]?.symbol ?? currency;
};
